import { useCallback, useState } from "react";

export const useUserAdmin = () => {
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentUser, setCurrentUser] = useState(null); // Store the user being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentUser(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((user) => {
    setEditMode(true);
    setCurrentUser(user);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    editMode,
    currentUser,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  };
};
